// A venue that absorbs the fee charges the guest nothing, and PaymentItem omits a zero
// row unless showZeroValue is passed — which no fee line does. Extracted so the two
// halves of that behaviour are testable together rather than restated in a test.
export const getVisibleProcessingFee = (processingFee: number, processingFeeAbsorbed?: boolean) =>
    processingFeeAbsorbed ? 0 : processingFee;
